module.exports = __webpack_public_path__ + "static/media/carousel_3.8d7115c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/carousel_3.jpg
// module id = 167
// module chunks = 0